// extracted by mini-css-extract-plugin
export default {"quantity":"Quantity_quantity__zilg2","quantityNumber":"Quantity_quantityNumber__4NOvv"};